// extracted by mini-css-extract-plugin
export default {"dashboard":"ADashboard_dashboard__yewpb"};